const hubspotUrl =
  import.meta.env.VITE_POCO_SUNSET_HUBSPOT_URL || 'https://app.hubspot.com/contacts/556151';
const archiveContactLabel = import.meta.env.VITE_POCO_SUNSET_ARCHIVE_CONTACT_LABEL || 'Media Garcia ops';
const archiveContactUrl = import.meta.env.VITE_POCO_SUNSET_ARCHIVE_CONTACT_URL;

export default function Sunset() {
  return (
    <main className="min-h-screen bg-background text-foreground">
      <section className="mx-auto flex min-h-screen w-full max-w-4xl flex-col justify-center px-6 py-12">
        <div className="mb-10 flex items-center gap-4">
          <img src="/poco-logo-dark-small.png" alt="POCO" className="h-12 w-12 rounded" />
          <div>
            <p className="text-sm uppercase text-muted-foreground">POCO</p>
            <h1 className="text-3xl font-semibold sm:text-5xl">Moved to HubSpot</h1>
          </div>
        </div>

        <div className="space-y-6 text-lg leading-8 text-muted-foreground">
          <p>
            POCO is no longer the operational workspace for Media Garcia client work. Active
            projects, tasks, client decisions, and follow-up work now belong in HubSpot.
          </p>
          <p>
            The POCO archive is being retained for export validation, audit history, and reference
            lookups during the teardown window.
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <a
            href={hubspotUrl}
            className="inline-flex min-h-11 items-center justify-center rounded-md bg-primary px-5 py-3 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background"
          >
            Open HubSpot
          </a>
          {archiveContactUrl ? (
            <a
              href={archiveContactUrl}
              className="inline-flex min-h-11 items-center justify-center rounded-md border border-border px-5 py-3 text-sm font-medium text-foreground transition-colors hover:bg-accent focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background"
            >
              Request Archive Access
            </a>
          ) : null}
        </div>

        <dl className="mt-12 grid gap-4 border-t border-border pt-6 text-sm sm:grid-cols-3">
          <div>
            <dt className="text-muted-foreground">System status</dt>
            <dd className="mt-1 font-medium">Read-only sunset</dd>
          </div>
          <div>
            <dt className="text-muted-foreground">Source of truth</dt>
            <dd className="mt-1 font-medium">HubSpot Projects</dd>
          </div>
          <div>
            <dt className="text-muted-foreground">Archive owner</dt>
            <dd className="mt-1 font-medium">{archiveContactLabel}</dd>
          </div>
        </dl>
      </section>
    </main>
  );
}
